import {Doorbell} from "@variocube/app-api";
import {EventSource} from "../EventSource";

export class MockDoorbell implements Doorbell {
	public readonly ringEvent = new EventSource<string>();

	async ring(serialNumber: string): Promise<any> {
		this.ringEvent.safeInvokeListeners(serialNumber);
	}
}
